/**
 * @desc        Sensor Payload Reducer
 * @version     1.1 - 1 feb 22 **/

import * as actionTypes from '../../actions/action-types.js'

const initialState = {
    lastlist: {
        lastFetch: 0,
        loading: false,
    },
    sensor: {
        lastFetch: 0,
        loading: false,
    },
}
const sensor = (state = initialState, action) => {
    const { data, type } = action
    switch (type) {
        case actionTypes.STORE_INIT:
            return {
                ...initialState,
            }

        case actionTypes.FD_PAYLD_LL_REQUEST:
            return {
                ...state,
                lastlist: { ...state.lastlist, loading: true },
            }

        case actionTypes.FD_PAYLD_LL_REQUEST_SUCCESS:
            return {
                ...state,
                lastlist: {
                    ...state.lastlist,
                    loading: false,
                    lastFetch: Date.now(),
                    data: data,
                },
            }
        case actionTypes.FD_PAYLD_LL_REQUEST_FAILURE:
            return {
                ...state,
                lastlist: {
                    loading: false,
                    error: action.error,
                    lastError: Date.now(),
                },
            }
        case actionTypes.FD_PAYLD_SEN_REQUEST:
            return {
                ...state,
                sensor: { ...state.sensor, loading: true },
            }

        case actionTypes.FD_PAYLD_SEN_REQUEST_SUCCESS:
            return {
                ...state,
                sensor: {
                    ...state.sensor,
                    loading: false,
                    lastFetch: Date.now(),
                    data: data,
                },
            }
        case actionTypes.FD_PAYLD_SEN_REQUEST_FAILURE:
            return {
                ...state,
                sensor: {
                    loading: false,
                    error: action.error,
                    lastError: Date.now(),
                },
            }
        default: {
            return state
        }
    }
}

export default sensor
